// eslint-disable-next-line
import lazySizes from 'lazysizes'
import 'lazysizes/plugins/bgset/ls.bgset'
import 'lazysizes/plugins/parent-fit/ls.parent-fit'

Object.assign(lazySizes.cfg, {
  expFactor: 4,
  expand: 1000,
})



// WEBPACK FOOTER //
// ./scripts/autoload/_general.js